import * as Yup from 'yup'
import { Accordion, Form } from 'react-bootstrap'
import { CustomAccordionButton, CustomFormControl } from '../../../../StyledComponents';
import { checkGrade, checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    vocationalTraining1: checkText(settings),
    vocationalTraining2: checkText(settings),
    vocationalTraining3: checkText(settings),
    vocationalTrainingGrade1: checkGrade,
    vocationalTrainingGrade2: checkGrade,
    vocationalTrainingGrade3: checkGrade,
});

export const VocationalTrainingSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Accordion defaultActiveKey={['0']} alwaysOpen>
                <Accordion.Item eventKey="0">
                    <CustomAccordionButton colors={colors}>Berufsausbildung 1</CustomAccordionButton>
                    <Accordion.Body>
                        <Form.Group className="mb-3" controlId="formVocationalTraining1">
                            <Form.Label>Abschluss</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschluss"
                                type="text"
                                name="vocationalTraining1"
                                value={values.vocationalTraining1}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.vocationalTraining1 && !errors.vocationalTraining1}
                                isInvalid={errors.vocationalTraining1}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.vocationalTraining1}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formVocationalTraining1Grade">
                            <Form.Label>Note</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Note"
                                type="number"
                                name="vocationalTrainingGrade1"
                                value={values.vocationalTrainingGrade1 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.vocationalTrainingGrade1 && !errors.vocationalTrainingGrade1}
                                isInvalid={errors.vocationalTrainingGrade1}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.vocationalTrainingGrade1}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <CustomAccordionButton colors={colors}>Berufsausbildung 2</CustomAccordionButton>
                    <Accordion.Body>
                        <Form.Group className="mb-3" controlId="formVocationalTraining2">
                            <Form.Label>Abschluss</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschluss"
                                type="text"
                                name="vocationalTraining2"
                                value={values.vocationalTraining2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.vocationalTraining2 && !errors.vocationalTraining2}
                                isInvalid={errors.vocationalTraining2}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.vocationalTraining2}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formVocationalTraining2Grade">
                            <Form.Label>Note</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Note"
                                type="number"
                                name="vocationalTrainingGrade2"
                                value={values.vocationalTrainingGrade2 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.vocationalTrainingGrade2 && !errors.vocationalTrainingGrade2}
                                isInvalid={errors.vocationalTrainingGrade2}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.vocationalTrainingGrade2}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <CustomAccordionButton colors={colors}>Berufsausbildung 3</CustomAccordionButton>
                    <Accordion.Body>
                        <Form.Group className="mb-3" controlId="formVocationalTraining3">
                            <Form.Label>Abschluss</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Abschluss"
                                type="text"
                                name="vocationalTraining3"
                                value={values.vocationalTraining3}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.vocationalTraining3 && !errors.vocationalTraining3}
                                isInvalid={errors.vocationalTraining3}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.vocationalTraining3}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formVocationalTraining3Grade">
                            <Form.Label>Note</Form.Label>
                            <CustomFormControl
                                colors={colors}
                                placeholder="Note"
                                type="number"
                                name="vocationalTrainingGrade3"
                                value={values.vocationalTrainingGrade3 || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isValid={touched.vocationalTrainingGrade3 && !errors.vocationalTrainingGrade3}
                                isInvalid={errors.vocationalTrainingGrade3}
                                maxLength={settings.textInputLimit}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.vocationalTrainingGrade3}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
};